export const ISRESULT = 'ISRESULT';
//Login
export const GET_DATA_LOGIN_LOGIN = 'GET_DATA_LOGIN_LOGIN';
export const GET_DATA_LOGIN_LOGIN_SUCCEEDED = 'GET_DATA_LOGIN_LOGIN_SUCCEEDED';
export const REQUERT_LOGIN_LOGIN_FAILED = 'REQUERT_LOGIN_LOGIN_FAILED';
export const SET_DATA_LOGIN_LOGIN = 'SET_DATA_LOGIN_LOGIN';
export const LOGIN = 'LOGIN';
export const LOGIN_SUCCEEDED = 'LOGIN_SUCCEEDED';
export const LOGIN_FAILED = 'LOGLOGIN_FAILEDIN';
//IndexHygen